import React from "react";
import {
    Box,
    Button,
    Typography,
    useMediaQuery,
    useTheme,
    Grid,
    Paper,
  } from "@mui/material";
import { LandingPageCards } from '../LandingPage1/LandingPageCards/LandingPageCards';
import { MenuLandingPageCard } from "./MenuLandingPageCard";
export default function TrendingMenu({menus}) {
  return (
    <>
      <Box component="container">
        <Box>
          <Typography
            sx={{
              fontSize: {
                xl: "40px",
                lg: "40px",
                md: "40px",
                sm: "36px",
                xs: "30px",
              },
              fontWeight: "600",
              pb: "16px",
              width: {
                xl: "1200px",
                lg: "569px",
                md: "569px",
                sm: "569px",
                xs: "320px",
              },
            }}
          >
            There’s trending menu for you !
          </Typography>
        </Box>
        <Box
         sx={{
          // mt: {xl: "60px", lg: "0px", md: "0px", xs: "0px", sm: "0px"}
         }}>
            {/* <LandingPageCards menus={menus}/> */}
            <MenuLandingPageCard menus={menus}/>
        </Box>
      </Box>
    </>
  );
}
